import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import LanguageSelector from "./LanguageSelector";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // ✅ import i18next hook

const Header = () => {
    const [isSearchBarOpen, setSearchBarOpen] = useState(false);
    const toggleSearchBar = () => setSearchBarOpen(!isSearchBarOpen);
    const { lang } = useParams();   // no = "en"

    const { t, i18n } = useTranslation(); // get i18n instance

    // ✅ Sync i18n language with URL parameter
    useEffect(() => {
        if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return (
        <header className="header">
            <Navbar expand="lg">
                <div className="container header">
                    <div className="col-2">
                        <a href="/" className="navbar-brand">
                            <span className="logo-text">{t("header.logo", { defaultValue: "Blank-text.net" })}</span>
                        </a>
                    </div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="col-8">
                        <Nav className="mx-auto">
                            <Nav.Link as={Link} to={`/${lang}`}>{t("header.home")}</Nav.Link>
                            <Nav.Link as={Link} to={`/${lang}/about`}>{t("header.about")}</Nav.Link>
                            <Nav.Link as={Link} to={`/${lang}/blog`}>{t("header.blog")}</Nav.Link>
                            <Nav.Link as={Link} to={`/${lang}/contact`}>{t("header.contact")}</Nav.Link>
                        </Nav>

                        <div className="nav__right__btn">
                            <LanguageSelector />
                            <label
                                className="search-top"
                                onClick={toggleSearchBar}
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    id="search-icon-image"
                                    loading="lazy"
                                    src="https://www.editpad.org/web_assets/frontend/images/search-icon.svg"
                                    className="search-icon-image"
                                    alt="search"
                                />
                            </label>
                        </div>
                        <div className="nav-btn"></div>
                    </Navbar.Collapse>
                </div>
            </Navbar>

            {/* Full-Screen Search Bar */}
            {isSearchBarOpen && (
                <div className="search-overlay">
                    <div className="search-box">
                        <input
                            type="search"
                            placeholder={t("header.search_placeholder", { defaultValue: "Enter Search Term To Find Tool" })}
                            id="search_query"
                        />
                        <button>{t("header.search_button", { defaultValue: "Search" })}</button>
                    </div>
                    <span className="close-search" onClick={toggleSearchBar}>×</span>
                </div>
            )}
        </header>
    );
};

export default Header;
